// Icon
import ekg from 'url:view-base/type-icon-color/ekg.svg'
import copyIcon from 'url:view-base/type-icon/copy.svg'

// Build
import { html } from 'lit/html.js'
import 'view-base/unit-link'
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { uri } from '../data-util'
import langs from './language.json'
import * as immu from 'object-path-immutable'
import 'view-base/unit-button'
import cloneDeep from 'lodash/cloneDeep'
import textRisk from './textRisk'
import * as util from '../view-advice-util'

import { questions } from './questions'
import { textTable } from './textTable'
import { provider } from './provider'

// ----------------------------------------------
// Creator of text for view adivce and params
// drugs, rules, faqs come as ObjectById
// ----------------------------------------------
export function text( { drugs, rules, faqs } ) {

  const xeon = { drugs, rules, faqs }
  const data = provider( xeon )

  // Ensure language and enable manual override
  const lang = uri.lang()
  // Set dictionary appropiate for lang
  const dict = langs[ lang ]
  // Collect all html templates
  const parts = []

  // ---------------------------
  // Case: no wirkstoff
  // ---------------------------
  if ( data.drugsWith( 'nofilter' ).length == 0 ) {
    return parts.concat( html `
      <div class="box qtc">
        <h2>
          <img src="${ekg}" alt="${dict.alt}"/>
          <span>${dict.title}</span>
          <span style="flex:1"></span>
        </h2>
        <p style="margin-top:1.5rem;">${dict.nowirkstoff}</p>
      </div>
    ` )
  }

  // -----------------------------
  // Header QTC with icon
  // -----------------------------
  // Risk points only due to medication with qtc-prolonging drugs
  var level = 0;
  level += data.drugsWith( 'conditional' ).length * 0.25
  level += data.drugsWith( 'possible' ).length * 0.5
  level += data.drugsWith( 'known' ).length * 3
  //

  parts.push( html `
    <h2>
      <img src="${ekg}" alt="${dict.alt}"/>
      <span>${dict.title}</span>
      ${ util.build.up("abridge") }
      <span style="flex:1"></span>
      ${ util.build.hub(`docs/qtc/${lang}`) }
      <span class=bar></span>
      ${ util.build.copy("qtc") }
      <span class=bar></span>
      <span class=score>-${ data.score() }%</span>
    </h2>` )

  const replaceDrugs = util.replaceDrugs( dict.placeholder1, dict.placeholder2, lang )

  // ---------------------------------------
  // Shared text fragment for non qtc drugs
  // ---------------------------------------
  var textNoneQtc = ""
  if ( data.drugsWith( 'nonqtc' ).length > 0 ) {
    // Select name and color
    const single = dict.non_qtc_drugs1
    const plural = dict.non_qtc_drugs2
    const list = data.drugsWith( 'nonqtc' ).map( d => d[ "name" ][ lang ] )
    textNoneQtc = replaceDrugs( list, single, plural )
  }

  // --------------------------------
  // Case: only none qtc drugs
  // --------------------------------
  // http://localhost:5002/clinic/advice/de/?s=pravastatin,rosuvastatin/
  if ( data.drugsWith( 'qtc' ).length == 0 ) {
    parts.push( html `<p style="margin-top:1.5rem;">${unsafeHTML(textNoneQtc)}</p>` )
    return html `<div class="box qtc">${parts}</div>`
  }


  // ---------------
  // Table
  // ---------------
  parts.push( html `
    <section class=wide>${textTable(xeon)}</section>
  ` )


  // --------------------------------
  // Case: one possible drugs
  // --------------------------------
  // http://localhost:5002/clinic/advice/de/?s=pravastatin,rosuvastatin,alfuzosin
  if ( data.drugsWith( 'qtc' ).length == 1 && data.drugsWith( 'possible' ).length == 1 ) {
    // Select name and color
    const list = data.drugsWith( 'possible' ).map( d => d[ "name" ][ lang ] )
    const text = replaceDrugs( list, dict.possible_drug1 )
    parts.push( html `<p>${unsafeHTML(text)} ${unsafeHTML(textNoneQtc)}</p>` )
    return html `<div class="box qtc">${parts}</div>`
  }

  // --------------------------------
  // Case: one possible drugs
  // --------------------------------
  // http://localhost:5002/clinic/advice/de/?s=pravastatin,rosuvastatin,fluoxetin/
  if ( data.drugsWith( 'qtc' ).length == 1 && data.drugsWith( 'conditional' ).length == 1 ) {
    // Select name and color
    const list = data.drugsWith( 'conditional' ).map( d => d[ "name" ][ lang ] )
    const text1 = replaceDrugs( list, dict.conditional_drug1_emp )
    const text2 = replaceDrugs( list, dict.conditional_drug1_bew )
    parts.push( html `
      <p>
        <span class=chapter>${dict.empfehlung}:</span>
        <span class=over> ${unsafeHTML(text1)}</span>
      </p>
      <p>
        <span class=chapter>${dict.bewertung}:</span>
        <span> ${unsafeHTML(text2)} ${unsafeHTML(textNoneQtc)}</span>
      </p>
    ` )
    return html `<div class="box qtc">${parts}</div>`
  }

  // ---------------------------------------------------------------------
  // Case: qualify for RISQ-PATH
  // ---------------------------------------------------------------------
  // http://localhost:5002/clinic/advice/de/for-drug-pravastatin-rosuvastatin-ciprofloxacin/
  if ( data.drugsWith( 'qtc' ).length > 1 || data.drugsWith( 'known' ).length > 0 ) {

    // BUT list of questions not or partially answered
    if ( questions( { drugs, rules, faqs }, true ).length > 0 ) {
      // Empfehlung with link to fragen
      const empfehlung = util.replaceLink( dict.answer_question_emp, `/clinic/findings/${lang}/`, dict.placeholder3 )
      // Bwertung for all qtc drugs
      const list = data.drugsWith( 'qtc' ).map( d => d[ "name" ][ lang ] )
      const single = dict.answer_question_bew1
      const plural = dict.answer_question_bew2
      const bewertung = replaceDrugs( list, single, plural )
      parts.push( html `
        <p>
          <span class=chapter>${dict.empfehlung}:</span>
          <span class=over> ${unsafeHTML(empfehlung)}</span>
        </p>
        <p>
          <span class=chapter>${dict.bewertung}:</span>
          <span> ${unsafeHTML(bewertung)} ${unsafeHTML(textNoneQtc)}</span>
        </p>
      ` )
      return html `<div class="box qtc">${parts}</div>`
    }

    // ---------------------------------------------------------
    // Ready for risko path and questions have been answered
    // ---------------------------------------------------------
    // http://localhost:5002/clinic/advice/de/?s=metoclopramid,moclobemid,simvastatin&q=1q1v0,2q1v2,3q1v3,4q1v0,5q1v2,6q1v1,7q1v1,7q2v1,7q3v1,7q4v1,8q1v1,8q3v1,9q1v1,9q2v1,10q1v1,11q1v2,12q1v1,12q2v1,13q1v0,13q2v1,13q3v1,13q4v1,14q1v1,14q2v1,14q3v1,14q4v1/
    if ( questions( { drugs, rules, faqs }, true ).length == 0 ) {
      var { empfehlung, bewertung } = textRisk( { drugs, rules, faqs }, lang )
      parts.push( html `
        <p>
          <span class=chapter>${dict.empfehlung}:</span>
          <span class=over> ${unsafeHTML(empfehlung)}</span>
        </p>
        <p>
          <span class=chapter>${dict.bewertung}:</span>
          <span> ${unsafeHTML(bewertung)} ${unsafeHTML(textNoneQtc)}</span>
        </p>
      ` )
      return html `<div class="box qtc">${parts}</div>`
    }
  }

  return html `<div class="box qtc">${parts}</div>`
}